interface Size {
  width: string;
  height: string;
  mobWidth?: string;
  mobHeight?: string;
}

interface Sizes {
  [key: string]: Size;
}

export const sizes: Sizes = {
  insightsThumbnail: { width: '130px', height: '130px', mobWidth: '68px', mobHeight: '68px' },
  cropperImage: { width: '400px', height: '400px' },
  profileImage: { width: '40px', height: '40px' },
  tableImage: { width: '64px', height: '64px', mobWidth: '51px', mobHeight: '51px' },
  largeImageScreen: { width: '500px', height: '500px', mobWidth: '90%', mobHeight: '400px' },
  icon: { width: '20px', height: '20px' },
  profileImageTable: { width: '64px', height: '64px' },
};

interface BorderType {
  [key: string]: string;
}

export const borders: BorderType = {
  // Used by Image component
  rounded: '20px',
  circle: '100%',
};
